import { LOGIN, LOGOUT } from '../types';
import { RepositoryFactory } from '../../repository/RepositoryFactory';
var authRepository = RepositoryFactory.get('auth');

export const login = (payload) => async (dispatch) => {
  try {
    let { data } = await authRepository.login(payload);

    dispatch({
      type: LOGIN,
      payload: data
    });
    return true; // Login riuscito
  } catch (err) {
    alert(err.response.data.message);
    return false; // Login fallito
  }
};

export const loginSSO = (payload) => async (dispatch) => {
  try {
    let { data } = await authRepository.loginSSO(payload);

    dispatch({
      type: LOGIN,
      payload: data
    });
    return { success: true };
  } catch (err) {
    const message = err.response?.data?.message || 'Errore durante il login SSO';
    return { success: false, message };
  }
};

export const logout = () => async (dispatch) => {
  dispatch({
    type: LOGOUT
  });
};
